export const Sequential = {
    title: 'Sequential Image Classification',
    img: "https://production-media.paperswithcode.com/thumbnails/task/task-0000000961-6da1b793_turJtnf.jpg",
    description: "Sequential image classification is the task of classifying a sequence of images.",
    datasets: ["CIFAR-10","MNIST"],
    models: [
        
    ]
}

export default Sequential;